import { c as _c } from "react/compiler-runtime";
import type { ShopOpeningTime } from '@sbt-web/network/types';
import { getOpeningTime } from '@/client/components/Detail/AdvertiserInfo/AdDetailCompanyPro/mapper';
import classes from './index.module.scss';
interface OpeningTimeProps {
  openingTime: ShopOpeningTime;
}
export interface IOpeningTimeRow {
  type: string;
  name: string;
  firstColumn: string;
  secondColumn: string;
}
const OpeningTimeRow = t0 => {
  const $ = _c(10);
  const {
    name,
    firstColumn,
    secondColumn
  } = t0;
  let t1;
  if ($[0] !== name) {
    t1 = <th><p className="body-text">{name}</p></th>;
    $[0] = name;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== firstColumn) {
    t2 = <td><p className="body-text">{firstColumn}</p></td>;
    $[2] = firstColumn;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== secondColumn) {
    t3 = <td><p className="body-text">{secondColumn}</p></td>;
    $[4] = secondColumn;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <tr>{t1}{t2}{t3}</tr>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export const OpeningTimeTable = t0 => {
  const $ = _c(5);
  const {
    openingTime
  } = t0;
  let t1;
  if ($[0] !== openingTime) {
    t1 = getOpeningTime(openingTime).map(_temp);
    $[0] = openingTime;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const tableRows = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <caption className={classes.opening_time_caption}><span className="subheading">Orari</span></caption>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== tableRows) {
    t3 = <table>{t2}<tbody>{tableRows}</tbody></table>;
    $[3] = tableRows;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
function _temp(row, index) {
  return <OpeningTimeRow key={index} {...row} />;
}